import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingSpinner from '../common/LoadingSpinner';

interface OAuthCallbackProps {
  provider: 'linkedin' | 'twitter';
}

const OAuthCallback: React.FC<OAuthCallbackProps> = ({ provider }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');

      if (error) {
        // Send error to parent window
        window.opener?.postMessage({
          type: `${provider.toUpperCase()}_OAUTH_ERROR`,
          error: error
        }, window.location.origin);
        window.close();
        return;
      }

      if (!code) {
        window.opener?.postMessage({
          type: `${provider.toUpperCase()}_OAUTH_ERROR`,
          error: 'No authorization code received'
        }, window.location.origin);
        window.close();
        return;
      }

      if (provider === 'linkedin') {
        const redirectUri = `${window.location.origin}/oauth/linkedin/callback`;
        window.opener?.postMessage({
          type: 'LINKEDIN_OAUTH_CODE',
          code,
          redirectUri,
        }, window.location.origin);
      } else if (provider === 'twitter') {
        window.opener?.postMessage({
          type: 'TWITTER_OAUTH_CODE',
          code,
          state,
        }, window.location.origin);
      } else {
        window.opener?.postMessage({
          type: `${(provider as string).toUpperCase()}_OAUTH_ERROR`,
          error: `Unsupported provider: ${provider as string}`,
        }, window.location.origin);
      }
      window.close();
    };

    handleCallback();
  }, [location, provider]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <LoadingSpinner size="large" message={`Completing ${provider} authentication...`} />
      <p>Please wait while we complete your authentication.</p>
    </div>
  );
};

export default OAuthCallback;